/* eslint-disable react-hooks/exhaustive-deps */
import clsx from 'clsx'
import { Field, Formik } from 'formik'
import { useEffect, useState } from 'react'
import { Button } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import * as Yup from 'yup'
import AddressAutocomplete from './AutoComplete';
import { AppLog } from '../../../../_4threal/helpers'
// import { generatePopup } from '../../../../utils/popup'
import { cartPayment } from '../../../../redux/action/payment'
import { userProfile } from '../../../../redux/action/auth'
import { makePng } from '../../cardform/components/helpers/Helpers'
import { getFunctions, httpsCallable } from 'firebase/functions'

// import { getFunctions, httpsCallable } from 'firebase/functions'

const PrintManyModal = (props) => {
  const {
    parsedCart,
    svgCardRef,
    closeModal
  } = props

  const token = localStorage.getItem('userId')
  const dispatch = useDispatch()
  const functions = getFunctions()

  // const functions = getFunctions()
  // const getShipping = httpsCallable(functions, 'getShipping')

  // const [paymentProcessing, setPaymentProcessing] = useState<boolean>(false)
  // const [tax, setTax] = useState<number>(1)
  // const [shipping, setShipping] = useState<number>(0)
  const [loading, setLoading] = useState(false)
  // const [productCount, setProductCount] = useState<number>(0)
  // const [addValid, setAddValid] = useState<boolean>(false)
  const [loadingPrice, setLoadingPrice] = useState<boolean>(false)
  const [paymentSuccess, setPaymentSuccess] = useState<boolean>(false)
  // const loading = false
  const productCount = 0
  const addValid = false
  // const paymentSuccess = false
  const [address, setAddress] = useState<any>(null)
  const [paymentFail, setPaymentFail] = useState<boolean>(false)
  const environment = process.env.REACT_APP_ENVIRONMENT;
  const userdata = useSelector((state: any) => state.Auth?.authProfile?.userData)
  const currentYear = new Date().getFullYear() % 100
  const [subtotal, setSubtotal] = useState(0)
  const products = useSelector((state: any) => state.Api?.products || {})
  const [pricingResponse, setPricingResponse] = useState<any>({
    items:[],
    shipping: 0,
    total: 0,
    tax:0,
    subtotal:0,
    error: false,
    error_message: '',
    payment_processed: false
  })
  useEffect(() => {
    let subt = 0;
    Object.keys(parsedCart).forEach((sceneId) => {
      const markers:any = parsedCart[sceneId]?.markers
      Object.keys(markers).forEach(markerId => {
        subt += products[markers[markerId]?.type].price * markers[markerId]?.cart.quantity;
      })
    })
    setSubtotal(subt)
   }, [products])

  const defaultValues = {
    firstName: userdata?.firstName.trim() ? userdata?.firstName.trim() : '',
    lastName: userdata?.lastName.trim() ? userdata?.lastName.trim() : '',
    email: userdata?.protected?.email,
    ccNum: environment === 'production' ? '' : '4111111111111111',
    ccExp: environment === 'production' ? '' : '10/25',
    cvv: environment === 'production' ? '' : '999',
  }

  const validationSchema = Yup.object().shape({
    firstName: Yup.string()
      .min(3, 'Minimum 3 symbols')
      .max(50, 'Maximum 50 symbols')
      .required('First Name is required'),
    lastName: Yup.string()
      .min(3, 'Minimum 3 symbols')
      .max(50, 'Maximum 50 symbols')
      .required('Last Name is required'),
    ccNum: Yup.string()
      .matches(/^\d{15,16}$/, 'Invalid card number')
      .required('Card number is required'),
    ccExp: Yup.string()
      .matches(/^(0[1-9]|1[0-2])\/\d{2}$/, 'Invalid expiration date (MM/YY)')
      .test('is-valid-expiration', 'Invalid expiration date', function (value) {
        if (!value) {
          return true // The field is optional, so it's considered valid if empty
        }

        // Split the input into month and year
        const [inputMonth, inputYear] = value.split('/').map((str) => parseInt(str, 10))

        // Calculate the current month and year
        const currentMonth = new Date().getMonth() + 1 // Months are zero-indexed, so we add 1
        const currentFullYear = currentYear + (currentMonth <= 12 ? 2000 : 1900) // Handle the 2-digit year

        // Calculate the maximum allowed year (e.g., 10/20)
        const maxYear = currentMonth <= 12 ? currentFullYear + 10 : currentFullYear + 9

        // Convert the input year to a full year (e.g., 10/20 to 2010)
        const inputFullYear = inputYear + (inputYear >= currentYear ? 2000 : 1900)

        // Check if the input date is valid
        return (
          inputFullYear <= maxYear &&
          (inputFullYear > currentFullYear ||
            (inputFullYear === currentFullYear && inputMonth >= currentMonth))
        )
      })
      .required('Expiration date is required'),
    cvv: Yup.string()
      .matches(/^\d{3}$/, 'Invalid CVV')
      .required('CVV is required'),
  })

  const handleForward = () => {
    closeModal()
    if(paymentSuccess) {
      window.location.href = '/orders'
    }
  }

  // NOTE: get tax logic from here

  // useEffect(() => {
  //   if (printMarker?.cardType in products && productCount > 0) {
  //     const gs = async (payload) => {
  //       setLoadingPrice(true)
  //       const shipping: any = await getShipping(payload)
  //       if (!shipping?.data?.shipping?.error) {
  //         setShipping(parseFloat(shipping.data?.shipping?.data?.rate))
  //       } else {
  //         setShipping(0)
  //       }

  //       if (!shipping?.data?.taxes?.error) {
  //         if (shipping.data?.taxes?.data?.required) {
  //           if (shipping.data?.taxes?.data?.shipping_taxable) {
  //             setShipping(parseFloat(shipping.data?.shipping?.data?.rate) * (parseFloat(shipping.data?.taxes?.data?.rate) + 1))
  //           } else {
  //             setTax(parseFloat(shipping.data?.taxes?.data?.rate) + 1)
  //           }
  //         } else (
  //           setTax(1)
  //         )

  //       } else {
  //         setTax(0)
  //       }
  //       setLoadingPrice(false)
  //       AppLog('shipping', shipping)
  //     }

  //     let payload = {
  //       recipient: address,
  //       items: [
  //         {
  //           variant_id: products[printMarker?.type]['variant_id'],
  //           quantity: productCount
  //         }
  //       ]
  //     }

  //     gs(payload)
  //   }
  // }, [productCount]) // eslint-disable-line react-hooks/exhaustive-deps

  // const handleQuantityChange = async (val) => {
  //   if (!address) {
  //     setAddValid(false)
  //     generatePopup('error', 'Please Enter a valid Shipping Address to Continue.');
  //     return
  //   }

  //   const minimum = products[printMarker?.type].minimum
  //   if (productCount <= minimum && val < 0) {
  //     setProductCount(0)
  //     return
  //   }

  //   if (productCount < minimum && val > 0) {
  //     setProductCount(minimum)
  //     return
  //   }

  //   setProductCount(productCount + val)
  // }

  const handleAddressSelect = async (place: any) => {
    AppLog('Selected Place:', place);
    let address = {}
    let recipient = {}
    place?.address_components?.forEach((component) => {
      if (component.types.includes('postal_code')) {
        address['zip'] = component.long_name
      }

      if (component.types.includes('street_number')) {
        address['street'] = component.long_name
      }

      if (component.types.includes('route')) {
        address['route'] = component.long_name
      }

      if (component.types.includes('premise')) {
        address['premise'] = component.long_name
      }

      if (component.types.includes('locality')) {
        address['city'] = component.long_name
      }

      if (component.types.includes('administrative_area_level_1')) {
        address['state'] = component.short_name
      }
    });

    recipient['address1'] = address['street'] + ' ' + address['route']
    recipient['country_code'] = 'US'
    recipient['state_code'] = address['state']
    recipient['city'] = address['city']
    recipient['zip'] = address['zip']
    if ('premise' in address) {
      recipient['address2'] = address['premise']
    } else {
      recipient['address2'] = ''
    }
    setAddress(recipient)
  }

  useEffect(() => {
    setLoadingPrice(true)
    const process = async (payload) => {
      const processCart = httpsCallable(functions, 'processCart')
      let res:any = await processCart(payload)
      setLoadingPrice(false)
      if (res.error) {
        console.log(res.error_message)
      } else {
        console.log('pricingResponse', res)
        setPricingResponse(res?.data)
      }
    }

    if (!address){
      return;
    }
    const payload = createPayload(address)
    console.log('payload', payload)
    process(payload)


  }, [address])


  const createPayload = (recipient, ccinfo:any = {}) => {
    let process = true;

    if (Object.keys(ccinfo).length === 0) {
      process = false;
    }

    let paymentPayload:any = {
      billingInfo: recipient,
      ccInfo: ccinfo,
      cartItems: [],
      offerCode: '',
      process: process,
    }

    //let printUrlPromises:any = []

    Object.keys(parsedCart).forEach(sceneId => {
      const scene = parsedCart[sceneId]
      const markers = scene.markers
      Object.keys(markers).forEach((markerId, i) => {
        const marker = markers[markerId];
        //const width  = Math.round((products[marker?.type]?.file?.border_w * 300) / 2) || 0
       // const height = Math.round((products[marker?.type]?.file?.border_h * 300) / 2) || 0
        //printUrlPromises[i] = dispatch(makePng(svgCardRef.current[marker?._id], width, height, marker?.type))
        let cart = marker.cart
        const cartitem = {
          marker_id: marker?._id,
          quantity: cart.quantity,
          price:cart.price,
          printful_variant_id:products[marker?.type]?.printful_variant_id,
          variant_id: products[marker?.type]?.variant_id,
          product_id: products[marker?.type]?.product_id,
        }
        paymentPayload.cartItems.push(cartitem)
      })
    })

    return paymentPayload

  }

  const handleFormSubmit = async (values: any, { resetForm }) => {

    //generatePopup('error', 'Under construction! The payment will fail because the Firebase logic is in progress.')

    //console.log('token', token)

    let paymentPayload = {
      billingInfo: {
        first_name: values?.firstName,
        last_name: values?.lastName,
        email: values?.email,
      },
      userId: token,
      ccNum: values?.ccNum,
      ccExp: values?.ccExp,
      cvv: values?.cvv,
      // markerId: printMarker?._id,
      cardId: "",
      quantity: productCount
    }

    let cartItemsPayload: any[] = []
    // let subt = 0;
    Object.keys(parsedCart).forEach(sceneId => {
      const markers = parsedCart[sceneId]?.markers
      Object.keys(markers).forEach(async markerId => {
        const marker = markers[markerId];
        const width  = Math.round((products[marker?.type]?.file?.border_w * 300) / 2) || 0
        const height = Math.round((products[marker?.type]?.file?.border_h * 300) / 2) || 0
        const imgdata: any = await dispatch(
          makePng(svgCardRef.current[marker?._id], width, height, marker?.type)
        )

        //console.log('imgdata', imgdata)

        let formattedCartItem: any = {}

        formattedCartItem['printUrl'] = imgdata;
        formattedCartItem['recipient'] = address
        formattedCartItem['cardType']  = marker?.type;
        formattedCartItem['variantId'] = products[marker?.type]['variant_id']
        formattedCartItem['printful_variant_id'] = products[marker?.type]['printful_variant_id']
        formattedCartItem['productId'] = products[marker?.type]['product_id']
        formattedCartItem['quantity'] = products[marker?.type]['quantity']
        // formattedCartItem['tax'] = tax;
        // formattedCartItem['shipping'] = shipping;

        cartItemsPayload.push(formattedCartItem)
      })
    })

    paymentPayload['cartItems'] = cartItemsPayload

    // After the data has been formatted, send the batch payment info to Firebase

    setLoading(true)
    // setPaymentProcessing(true)
    //console.log(paymentProcessing)
    dispatch(cartPayment(paymentPayload))
    .then((res) => {
      //console.log("Payment Response:", res)
      if (res.error) {
        setPaymentFail(true)
        resetForm();
      } else {
        setPaymentSuccess(true)
      }
      setLoading(false)
    })
    .finally(async (res: any) => {
      await dispatch(userProfile(token))
    })
  }

  const handleKeyDown = (e: any) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      const form = e.target.form
      const index = Array.prototype.indexOf.call(form, e.target)
      if (form.elements[index + 1]) {
        form.elements[index + 1].focus()
      }
    }
  }

  // const getPriceOfOne = () => {
  //   return (-1).toFixed(2) //(((productCount * products[printMarker?.type].price) * tax) + shipping).toFixed(2)
  // }

  return (
    <div className='row'>
      <div className='col-12'>
        <Formik initialValues={defaultValues} validationSchema={validationSchema} onSubmit={handleFormSubmit} enableReinitialize>
          {(formik) => {
            return (
              <form id='kt_modal_add_user_form' className='form' encType='multipart/form-data' onSubmit={formik.handleSubmit}>
                <div className='w-100'>
                  <div className='bg-white rounded-md p-5'>
                    {!paymentSuccess && !paymentFail && !loading ? (
                      <>
                        <div className='row mb-3'>
                          <div className='col-sm-6'>
                            <div style={{ width: '100%' }} className=''>
                              <label className='required fw-bold fs-8 mb-2'>First Name</label>
                              <div>
                                <Field
                                  className={clsx( 'form-control form-control-solid mb-3 mb-lg-0', { 'is-invalid': formik.touched.firstName && formik.errors.firstName, }, { 'is-valid': formik.touched.firstName && !formik.errors.firstName, } )}
                                  placeholder='Name on Card' type='text' name='firstName' autoComplete='off' disabled={formik.isSubmitting} onKeyDown={handleKeyDown}
                                  onChange={(e) => {
                                    const inputValue = e.target.value
                                    if (!inputValue.match(/^[A-Za-z][A-Za-z\s]*$/)) {
                                      e.target.value = inputValue.replace(/[^A-Za-z\s]/g, '');
                                      // Ensure the first character is a letter
                                      if (e.target.value && !e.target.value[0].match(/[A-Za-z]/)) {
                                        e.target.value = e.target.value.substring(1);
                                      }
                                    }
                                    formik.handleChange(e)
                                  }}
                                />
                                {formik.touched.firstName && formik.errors.firstName && (
                                  <div className='fv-plugins-message-container'>
                                    <div className='fv-help-block'>
                                      <span role='alert'>
                                        {Array.isArray(formik.errors.firstName)
                                          ? (formik.errors.firstName as string[]).join(', ')
                                          : (formik.errors.firstName as string)}
                                      </span>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                          <div className='col-sm-6'>
                            <div style={{ width: '100%' }} className=''>
                              <label className='required fw-bold fs-8 mb-2'>Last Name</label>
                              <div>
                                <Field
                                  className={clsx('form-control form-control-solid mb-3 mb-lg-0', { 'is-invalid': formik.touched.lastName && formik.errors.lastName, }, { 'is-valid': formik.touched.lastName && !formik.errors.lastName, })}
                                  placeholder='Name on Card' type='text' name='lastName' autoComplete='off' disabled={formik.isSubmitting} onKeyDown={handleKeyDown}
                                  onChange={(e) => {
                                    const inputValue = e.target.value
                                    if (!inputValue.match(/^[A-Za-z][A-Za-z\s]*$/)) {
                                      e.target.value = inputValue.replace(/[^A-Za-z\s]/g, '');
                                      // Ensure the first character is a letter
                                      if (e.target.value && !e.target.value[0].match(/[A-Za-z]/)) {
                                        e.target.value = e.target.value.substring(1);
                                      }
                                    }
                                    formik.handleChange(e)
                                  }}
                                />
                                {formik.touched.lastName && formik.errors.lastName && (
                                  <div className='fv-plugins-message-container'>
                                    <div className='fv-help-block'>
                                      <span role='alert'>
                                        {Array.isArray(formik.errors.lastName)
                                          ? (formik.errors.lastName as string[]).join(', ')
                                          : (formik.errors.lastName as string)}
                                      </span>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className='row'>
                          <div className='col-sm-4'>
                            <div style={{ width: '100%' }}>
                              <label className='required fw-bold fs-8 mb-2'>Card Number</label>
                              <Field
                                className={clsx('form-control form-control-solid mb-3 mb-lg-0 border', { 'is-invalid': formik.touched.ccNum && formik.errors.ccNum }, { 'is-valid': formik.touched.ccNum && !formik.errors.ccNum, })}
                                placeholder='Card Number' type='text' name='ccNum' autoComplete='off' disabled={formik.isSubmitting} onKeyDown={handleKeyDown}
                                onChange={(e) => {
                                  // Allow only numeric input
                                  const numericValue = e.target.value.replace(/[^0-9]/g, '')
                                  // Enforce a 16-digit limit
                                  if (numericValue.length <= 16) {
                                    formik.handleChange({
                                      target: { name: 'ccNum', value: numericValue },
                                    })
                                  }
                                }}
                              />
                              {formik.touched.ccNum && formik.errors.ccNum && (
                                <div className='fv-plugins-message-container'>
                                  <div className='fv-help-block'>
                                    <span role='alert'>
                                      {Array.isArray(formik.errors.ccNum)
                                        ? (formik.errors.ccNum as string[]).join(', ')
                                        : (formik.errors.ccNum as string)}
                                    </span>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                          <div className='col-sm-4'>
                            <div style={{ width: '100%' }} className=''>
                              <label className='required fw-bold fs-8 mb-2'>Expiry</label>
                              <Field
                                className={clsx('form-control form-control-solid mb-3 mb-lg-0 border', { 'is-invalid': formik.touched.ccExp && formik.errors.ccExp }, { 'is-valid': formik.touched.ccExp && !formik.errors.ccExp, })}
                                placeholder='Expiry' type='text' name='ccExp' autoComplete='off' disabled={formik.isSubmitting} onKeyDown={handleKeyDown}
                                onChange={(e) => {
                                  let inputValue = e.target.value
                                  // Allow only digits
                                  inputValue = inputValue.replace(/\D/g, '')
                                  // Add a '/' after the first 2 digits
                                  if (inputValue.length > 2) {
                                    inputValue = inputValue.slice(0, 2) + '/' + inputValue.slice(2)
                                  }
                                  // Limit the input to a maximum of 5 characters (e.g., "12/34")
                                  e.target.value = inputValue.slice(0, 5)
                                  formik.handleChange(e)
                                }}
                              />
                              {formik.touched.ccExp && formik.errors.ccExp && (
                                <div className='fv-plugins-message-container'>
                                  <div className='fv-help-block'>
                                    <span role='alert'>
                                      {Array.isArray(formik.errors.ccExp)
                                        ? (formik.errors.ccExp as string[]).join(', ')
                                        : (formik.errors.ccExp as string)}
                                    </span>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                          <div className='col-sm-4'>
                            <div style={{ width: '100%' }} className=''>
                              <label className='required fw-bold fs-8 mb-2'>Cvv</label>
                              <Field
                                className={clsx('form-control form-control-solid mb-3 mb-lg-0 border', { 'is-invalid': formik.touched.cvv && formik.errors.cvv }, { 'is-valid': formik.touched.cvv && !formik.errors.cvv, })}
                                placeholder='Card Number' type='text' name='cvv' autoComplete='off' disabled={formik.isSubmitting} onKeyDown={handleKeyDown}
                                onChange={(e) => {
                                  // Allow only numeric input and limit to 3 characters
                                  e.target.value = e.target.value.replace(/[^0-9]/g, '').slice(0, 3)
                                  formik.handleChange(e)
                                }}
                              />
                              {formik.touched.cvv && formik.errors.cvv && (
                                <div className='fv-plugins-message-container'>
                                  <div className='fv-help-block'>
                                    <span role='alert'>
                                      {Array.isArray(formik.errors.cvv)
                                        ? (formik.errors.cvv as string[]).join(', ')
                                        : (formik.errors.cvv as string)}
                                    </span>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className='col-12'>
                          <div className='row'>
                            <div className='col-12'>
                              <AddressAutocomplete onAddressSelect={handleAddressSelect} valid={addValid} />
                            </div>
                          </div>
                        </div>
                        <div className='col-12'>
                          <div className='row'>
                            <div className='col-12'>
                            <label className='w-bold fs-8 mb-2'>Offer Code</label>
                              <input
                              className='form-control form-control-solid mb-3 mb-lg-0 border'
                              placeholder='Offer Code'
                              autoComplete='off'
                              name='offercode'
                              type='text' />
                            </div>
                          </div>
                        </div>
                        <div className='row mt-4'>
                          <div className='col-12'>
                            <div className='d-flex justify-content-between'>
                              <div className='fw-bold fs-6'>Subtotal:</div>
                              <div className='fw-bold fs-6'>
                                ${subtotal.toFixed(2)}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className='row mt-4'>
                          <div className='col-12'>
                            <div className='d-flex justify-content-between'>
                              <div className='fw-bold fs-6'>Tax:</div>
                              <div className='fw-bold fs-6'>
                                {!address ? 'Please Enter Address' : loadingPrice ? 'Calculating...' : '$' + pricingResponse.tax.toFixed(2)}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className='row mt-4'>
                          <div className='col-12'>
                            <div className='d-flex justify-content-between'>
                              <div className='fw-bold fs-6'>Shipping:</div>
                              <div className='fw-bold fs-6'>
                                {!address ? 'Please Enter Address' : loadingPrice ? 'Calculating...' : '$' + pricingResponse.shipping.toFixed(2)}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className='row mt-4'>
                          <div className='col-12'>
                            <div className='d-flex justify-content-between'>
                              <div className='fw-bold fs-6'>Total:</div>
                              <div className='fw-bold fs-6'>
                                {!address ? 'Please Enter Address' : loadingPrice ? 'Calculating...' : '$' + pricingResponse.total.toFixed(2)}
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    ) : (
                      <div style={{ textAlign: 'center', width: '100%' }}>
                        <h1 style={{ fontSize: '30px' }}>{paymentSuccess ? 'Your Payment Was Successful' : paymentFail ? 'Your Payment Was Declined' : 'Processing Payment'}</h1>
                        {productCount > 0 && paymentSuccess &&
                          <a href="/orders" style={{ fontSize: '15px' }}>Click here to view your print orders.</a>
                        }
                        <img style={{ width: '100%' }} alt='' src={paymentSuccess ? '/media/payment_success.gif' : paymentFail ? '/media/payment_fail.gif' : '/media/payment_processing.gif'} />
                      </div>
                    )}
                    <div className='text-center w-100 d-flex' style={{ paddingTop: "30px" }}>
                      <Button onClick={handleForward} type='reset' className='btn me-3 bg-light text-black border border-black' style={{ width: !paymentSuccess && !paymentFail ? '50%' : '100%' }} data-kt-users-modal-action='cancel' disabled={formik.isSubmitting || loading}>
                        {paymentSuccess ? ('Continue') : ('Close')}
                      </Button>
                      {(!paymentSuccess && !paymentFail)
                      ? <Button type='submit' className='btn bg-black text-light w-50' data-kt-users-modal-action='submit' disabled={formik.isSubmitting || !formik.touched || loading || pricingResponse?.items.length === 0 || pricingResponse?.error}>
                          <span className='indicator-label'>
                            {loading ? 'Loading...' : 'Pay Now'}
                          </span>
                          {formik.isSubmitting && (
                            <span className='indicator-progress'>
                              Please wait...{' '}
                              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                            </span>
                          )}
                        </Button>
                      : paymentFail
                        ? <Button onClick={() => setPaymentFail(false)} className='btn bg-black text-light w-50' data-kt-users-modal-action='cancel' disabled={formik.isSubmitting || pricingResponse?.items.length === 0 || pricingResponse?.error}>
                            Try Again
                          </Button>
                        : <></>
                      }
                    </div>
                  </div>
                </div>
              </form>
            )
          }}
        </Formik>
      </div>
    </div>
  )
}

export default PrintManyModal
